export default __webpack_public_path__ + "static/media/front-img.4b4a5a74.svg";